import { Action } from 'helpers/action-helpers';
import { ActionProps, ConnectedProps, operationGrid } from './component';
import { AppState } from 'pages/app/state';
import { connect, Dispatch } from 'react-redux';
import { DesktopHeaders } from '../headers/desktop-headers';
import { DesktopRow, MobileRow } from './row';
import { getCurrentClientTransactionIds } from '../selectors';
import { Guid } from 'types/guid';
import { languageSelector } from 'pages/settings/selectors';
import { MobileHeaders } from '../headers/mobile-headers';
import { SetSelectedClientTransactionIdAction } from '../actions';

function mapStateToProps(state: AppState): ConnectedProps {
  return {
    language: languageSelector(state),
    clientTransactionIds: getCurrentClientTransactionIds(state)
  };
}

function mapDispatchToProps(dispatch: Dispatch<Action>): ActionProps {
  return {
    setSelectedTransactionId: (id: Guid) => dispatch(new SetSelectedClientTransactionIdAction(id))
  };
}

export const DesktopGridView = connect(mapStateToProps, mapDispatchToProps)(operationGrid(DesktopHeaders, DesktopRow));
export const MobileGridView = connect(mapStateToProps, mapDispatchToProps)(operationGrid(MobileHeaders, MobileRow));


// WEBPACK FOOTER //
// ./src/components/operation-grid/rows/index.ts